module.exports = __webpack_public_path__ + "img/lychee-350x184.c3013a53.jpg";